module.exports = __webpack_public_path__ + "img/icon-compose-gray.d779b037.svg";